<template>
    <div id="message_detail">
        <div class="message_detail">
            <div class="message_detail1">
                <div class="message_detail1_1 cursor_1" @click="goBack">
                    <img src="@/assets/image/icon_right.png" alt="">
                    返回
                </div>
                <div style="text-align: center;" v-if="result">
                    <p style="padding: 15px 0;font-size: 20px;font-weight: bold;">{{ result?.title }}</p>
                    <p style="font-size: 14px !important;color: #8f8f8f;padding: 15px 0;">
                        <span>辅导老师：{{ result?.mentor.nickname || '不知' }}</span>
                        <span class="t-p-l-20">发布时间：{{ result?.releaseTime }}</span>
                    </p>
                </div>
                <div class="flex-row">
                    <div v-if="result && bought" class="classroomDetailBtn" @click.stop="payClick">再次购买<span
                            class="t-p-l-6">¥</span><span
                            style="font-size: 20px !important;margin-top: -3px;margin-left: 3px;">{{ result?.price
                            }}</span>
                    </div>
                    <div v-if="result && !result?.qual && !bought" class="classroomDetailBtn" @click.stop="payClick">{{bought?'再次购买':'立即购买'}}<span
                            class="t-p-l-6">¥</span><span
                            style="font-size: 20px !important;margin-top: -3px;margin-left: 3px;">{{ result?.price
                            }}</span>
                    </div>
                    <el-popover placement="left" trigger="click" popper-class="el-set">
                        <img width="225" height="300" src="@/assets/image/icon_gzh.png" alt="">
                        <div slot="reference">
                            <div v-if="result && result?.qual && !bought" class="classroomDetailBtn">报名咨询</div>
                        </div>
                    </el-popover>
                </div>
            </div>
            <div class="message_detail2">
                <div v-html="html"></div>
            </div>
        </div>
        <Pay ref="payMoney"></Pay>
        <RightDisplayArea :showApp="false"></RightDisplayArea>
    </div>
</template>
<script>
import CApi from '@/api/classroom';
import { EventBus } from '@/utils/eventBus'
import Pay from '@/components/classroom/pay.vue'
import RightDisplayArea from '@/components/dongeb/RightDisplayArea.vue'
export default {
    components: {
        Pay, RightDisplayArea
    },
    data() {
        return {
            html: '',
            result: null,
            resizeHandler: null,
            bought:false,
        }
    },
    mounted() {
        let { detailId,bought } = this.$route.query
        this.bought = bought;
        if (detailId) {
            this.detailId = detailId
            this.getDynamicsDetail(this.detailId)
        }
        this.getUserLoginState(false)
        this.handleVideoResize(); // 初始调整一次
        // 窗口大小改变时也重新调整
        window.addEventListener('resize', this.handleVideoResize);
    },
    beforeDestroy() {
        // 确保处理函数存在后再移除
        if (this.handleVideoResize) {
            window.removeEventListener('resize', this.handleVideoResize);
        }
    },
    methods: {
        getDynamicsDetail(id) {
            CApi.classroomDetail({ id }).then((res) => {
                if (res.code === 200) {
                    // 创建Shadow DOM容器
                    this.html = res.data?.content;
                    this.result = res.data
                    this.$nextTick().then(_ => {
                        // 获取所有视频iframe
                        const videoIframes = document.querySelectorAll('.ql-video');

                        videoIframes.forEach(iframe => {
                            // 设置宽度为100%
                            iframe.style.width = '50%';

                            // 根据宽度计算高度(16:9比例)
                            const width = iframe.offsetWidth;
                            iframe.style.height = (width * 9 / 16) + 'px';
                        });
                    })
                }


            })
        },
        handleVideoResize() {
            this.$nextTick().then(() => {
                const videoIframes = document.querySelectorAll('.ql-video');
                videoIframes.forEach(iframe => {
                    const width = iframe.offsetWidth;
                    iframe.style.height = (width * 9 / 16) + 'px';
                });
            });
        },
        goBack() {
            this.$router.go(-1)
        },
        payClick() {
            if (this.loginState) {
                EventBus.$emit('openLogin')
                return
            }
            this.$refs.payMoney.openPrompt(this.result)
        }
    }

}
</script>

<style lang="scss" scoped>
p {
    margin: 0;
    padding: 0;
}

#message_detail {
    flex: 1;
    height: 100%;
    padding: 16px 0 0 20px;
    font-size: 15px;
    line-height: 0;
}

.message_detail {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
}

.message_detail1 {
    display: flex;
    align-items: center;
    height: 77px;
    border-bottom: 1px solid #E6EBF0;
    padding: 0 20px;
    position: relative;
    justify-content: space-between;
}

.message_detail1_1 {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    color: #111111;
}

.message_detail1_1 img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
}

.message_detail2 {
    width: 100%;
    height: calc(100% - 77px);
    padding: 25px 20px;
    overflow-y: auto;
    @include scrollbar();
   
    &:hover {
        @include scrollbar_hover()
    }
    ::v-deep(p){
        margin: 0 !important;
        padding: 0 !important;
    }
    img {
        object-fit: cover;
    }
}
</style>